import { useState } from "react";
import { MediaConstraints } from "../../types";

const useController = (
  constraints?: MediaConstraints | null,
  onChangeConstraints?: (constraints: MediaConstraints) => void
) => {
  const [facingMode, setFacingMode] = useState<"user" | "environment" | string>(
    constraints && typeof constraints.video === "object" && typeof constraints.video.facingMode === "string"
      ? constraints.video.facingMode
      : "user" ?? "user"
  );

  const onSwitchCam = async () => {
    if (!onChangeConstraints) return;
    const mode = facingMode === "user" ? "environment" : "user";
    const constraints: MediaConstraints = {
      video: {
        facingMode: mode,
      },
    };
    await onChangeConstraints(constraints);
    setFacingMode(mode);
  };

  return {
    onSwitchCam,
    facingMode,
  };
};

export default useController;
